<div appFormControl class="sortcode">
  <label [for]="sortOneId" class="sortcode__label"> Sortcode 1 </label>
  <input
    #sort1
    (focus)="onFocus()"
    (input)="onSortOneChange($event)"
    [attr.required]="required"
    [disabled]="disabled"
    [id]="sortOneId"
    [name]="id"
    [value]="sort1Subject | async"
    autocomplete="off"
    class="sortcode__input text--center"
    dgxFormNumericInput
    inputmode="decimal"
    maxlength="2"
    placeholder="XX"
    type="text"
  />

  <label [for]="sortTwoId" class="sortcode__label"> Sortcode 2 </label>
  <input
    #sort2
    (focus)="onFocus()"
    (input)="onSortTwoChange($event)"
    [attr.required]="required"
    [disabled]="disabled"
    [id]="sortTwoId"
    [name]="id"
    [value]="sort2Subject | async"
    autocomplete="off"
    class="sortcode__input text--center"
    dgxFormNumericInput
    inputmode="decimal"
    maxlength="2"
    placeholder="XX"
    type="text"
  />

  <label [for]="sortThreeId" class="sortcode__label"> Sortcode 3 </label>
  <input
    #sort3
    (focus)="onFocus()"
    (input)="onSortThreeChange($event)"
    [attr.required]="required"
    [disabled]="disabled"
    [id]="sortThreeId"
    [name]="id"
    [value]="sort3Subject | async"
    autocomplete="off"
    class="sortcode__input text--center"
    dgxFormNumericInput
    inputmode="decimal"
    maxlength="2"
    placeholder="XX"
    type="text"
  />
  @if (control.touched && control.enabled) {
    <app-validity-icon [valid]="control.valid" />
  }
</div>
